import { Component, Input, OnInit, inject } from '@angular/core';
import { StateService } from '../../shared/services/storage/state.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { NavigationEnd, Router, RouterLinkActive, RouterLink } from '@angular/router';
import { StoreRegionService } from '../../shared/services/store-region.service';
import { NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-mobile-navigation',
    templateUrl: './mobile-navigation.component.html',
    styleUrls: ['./mobile-navigation.component.scss'],
    standalone: true,
    imports: [RouterLinkActive, RouterLink, NgClass, MatButtonModule, TranslatePipe]
})
export class MobileNavigationComponent implements OnInit {
  private stateService = inject(StateService);
  private localStorageService = inject(LocalStorageService);
  private storeRegionService = inject(StoreRegionService);
  private router = inject(Router);

  @Input() isClubMember: boolean;
  isLoggedIn: boolean = false;
  hideNavigation: boolean = false;
  countryCode: string = '';

  ngOnInit(): void {
    this.countryCode = this.storeRegionService.selectedRegion?.code;
    this.hideNavigation = this.isNoneNavigationRoute;
    this.setLoginStatus();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.hideNavigation = this.isNoneNavigationRoute;
      }
    });
  }

  private get isNoneNavigationRoute() {
    return (
      this.router.url.includes('/authenticate') ||
      this.router.url.includes('/profile/edit') ||
      this.router.url.includes('/checkout') ||
      this.router.url.includes('/wallet/charge') ||
      this.router.url.includes('/payment') ||
      this.router.url.includes('/crypto')
    );
  }

  setLoginStatus() {
    this.stateService.setLoginStatus(this.localStorageService.isLoggedIn);
    let subscription = this.stateService
      .getLoginStatus()
      .subscribe((isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;
      });
  }

  goToOrderHistory() {
    this.router.navigate(['/profile/order-history']);
  }
}
